(function ClientImportProgress($, Adzuki)
{
	"use strict";

	var $progress_bar;

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/Clients/importingClients', function onload()
		{
			var client_import_id = $(".progress[data-client-import-id]").data('client-import-id');
			$progress_bar        = $(".progress-bar");
			startProgressCheck(client_import_id);
		});
	});

	function startProgressCheck(client_import_id)
	{
		Adzuki.Ajax.get('/Clients/importClientsProgress/'+client_import_id)
		.then(function _status(data)
		{
			var percentage = Math.round((data.processed / data.total) * 100);
			$progress_bar.css('width', percentage+'%').html(percentage+'%');

			if (data.processed === data.total) {
				window.location.href = Adzuki.base_uri + '/Clients/importResults';
			}
			else {
				setTimeout(function _poll() {
					startProgressCheck(client_import_id);
				}, 1500);
			}
		});
	}

}(jQuery, window.Adzuki || {}));
